import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class TransactionsApi {
  static getTransfers = (filters = {}, sort = {}) => {
    const queryParams = TransactionsApi.handleFiltersAndSort(filters, sort);
    const searchParams = new URLSearchParams(queryParams).toString();

    return axios.get(
      API_BASE_URL + '/transactions' + (searchParams ? '?' + searchParams : ''),
    );
  };

  static getTransferDetails = (transactionId) => {
    return axios.get(API_BASE_URL + `/transactions/${transactionId}`);
  };

  static createTransferBack = (transactionId) => {
    return axios.post(
      API_BASE_URL + `/transactions/${transactionId}/transfer-back`,
    );
  };

  static completePayment = (transactionId) => {
    return axios.post(API_BASE_URL + `/transactions/${transactionId}/complete`);
  };

  static cancelPayment = (paymentId, comment) => {
    return axios.post(API_BASE_URL + `/payments/${paymentId}/cancel`, {
      comment: comment,
    });
  };

  static handleFiltersAndSort = (filters, sort) => {
    const params = {};

    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;
    if (sort.key) params.sortBy = sort.key;
    if (sort.order) params.sortOrder = sort.order;
    if (filters.search) params.search = filters.search;
    if (filters.facilityId) params.facilityId = filters.facilityId;

    return Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
  };

  static addCheckFacility = (encodedId, skipCheck, checkType) => {
    return axios.post(API_BASE_URL + `/add_check_facility/${encodedId}`, {
      skipCheck: skipCheck,
      checkType,
    });
  };
}
